import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: "page-back-btn",
    onClick: $setup.handleClick
  }, [
    _createVNode($setup["ArrowLeft"], { size: 18 }),
    _cache[0] || (_cache[0] = _createElementVNode("span", null, "Back", -1))
  ]))
}